/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';

import RenderStaticHTML from '../RenderStaticHTML';
import Modal from '../Modal';
import GatsbyImage from '../GatsbyImage';
import Link from '../Link';

SwiperCore.use([Autoplay, EffectFade, Navigation]);

const ns = `banner`;

const HeaderBanner = ({items}) => {
	const [modal, setModal] = useState(false);
	const [{
		tag,
		title,
		image,
		description,
		link,
	}, setModalContent] = useState({});

	const openModal = content => {
		if (!content?.title) return;
		setModalContent({...content});
		setModal(true);
	};

	const closeModal = () => {
		setModal(false);
	};

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const bannerParam = params.get('banner');

		if (bannerParam === 'true') {
			const slideoutItem = items.find(item => item.title || item.description);
			slideoutItem && openModal(slideoutItem);
		}
		if (bannerParam) {
			const slideoutItem = items.find(item => item.title?.toLowerCase().trim() === bannerParam.toLowerCase().trim());
			slideoutItem && openModal(slideoutItem);
		}
	}, []); // eslint-disable-line

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--hidden`]: items.length < 2,
	});

	return (
		<div className={rootClassnames}>
			<Swiper
				navigation
				// loop
				slidesPerView={1}
				// loopedSlides={items.length}
				speed={1000}
				autoplay={{
					delay: 4000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				}}
				effect={'fade'}
				fadeEffect={{
					crossFade: true,
				}}
			>
				{items.map(item => (
					<SwiperSlide key={item.bannerContent}>
						{item.title
							? (
								<div
									role={`button`}
									tabIndex={0}
									aria-label={`modal`}
									onClick={() => openModal(item)}
									onKeyDown={event => {
										if (event.key === 'Enter' || event.key === ' ') {
											event.preventDefault();
											openModal(item);
										}
									}}
								>
									<RenderStaticHTML html={item.bannerContent} />
								</div>
							) : <RenderStaticHTML html={item.bannerContent} />}
					</SwiperSlide>
				))}
			</Swiper>
			<Modal
				variant={`drawer`}
				onRequestClose={closeModal}
				isOpen={modal}
			>
				<div className={`${ ns }__modal`}>
					{tag && <p className={`${ ns }__modal-tag`}>{tag}</p>}
					{title && <h3 className={`${ ns }__modal-title`}>{title}</h3>}
					{image && (
						<GatsbyImage
							mainImageMobile={image}
						/>
					)}
					{description && <RenderStaticHTML className={`${ ns }__modal-desc`} html={description} />}
					{link?.label
					&& (
						<button
							aria-label={link.label}
							onClick={closeModal}
						>
							<Link to={link?.url} className={'underline'}>{link.label}</Link>
						</button>
					)}
				</div>
			</Modal>
		</div>
	);
};

export default HeaderBanner;
